export const eduInternTranslations = {
  lv: {
    title: 'Praktikanti',
    description: 'Visi iestādes praktikanti visās praksēs.',
    count_zero: '{{count}} praktikantu',
    count_one: '{{count}} praktikants',
    count_other: '{{count}} praktikanti',
    statusTabs: 'Prakses statuss',
    statuses: {
      ongoing: 'Notiek',
      upcoming: 'Gaidāmās',
      finished: 'Beigušās',
      all: 'Visi',
    },
    search: 'Meklēt pēc vārda, uzvārda, personas koda…',
    empty: 'Praktikanti nav atrasti',
    noOrg: 'Nav piešķirta',
    columns: {
      group: 'Grupa',
      intern: 'Uzvārds, Vārds',
      pk: 'Personas kods',
      internship: 'Prakse',
      org: 'Uzņēmums',
      start: 'Sākums',
      end: 'Beigas',
      hours: 'Izpildīts/Kopā',
      categories: 'Kategorija',
    },
    orgs: {
      open: 'Prakses vietas',
      openFor: 'Prakses vietas: {{name}}',
      loading: 'Ielādē prakses vietas',
      loadError: 'Neizdevās ielādēt prakses vietas',
      agreement: 'Līgums',
      signatures: 'Paraksti',
      signature: '{{party}}: {{state}}',
      signed: 'parakstīts',
      notSigned: 'nav parakstīts',
      parties: {
        edu: 'Izglītības iestāde',
        intern: 'Praktikants',
        org: 'Prakses vieta',
      },
    },
    actions: {
      menu: 'Darbības',
      menuFor: 'Darbības: {{name}}',
      sections: {
        dates: 'Darbības ar datumiem',
        supervisors: 'Darbības ar prakses vadītājiem',
        other: 'Citas darbības',
      },
      items: {
        openCalendar: 'Apskatīt kalendāru',
        openDate: 'Atvērt noslēgtu datumu',
        changeDates: 'Mainīt prakses termiņu',
        resetDates: 'Atiestatīt prakses datumus',
        addAbsence: 'Atvērt prombūtni',
        closeAbsence: 'Noslēgt prombūtni',
        changeEduSupervisor: 'Mainīt prakses vadītāju izglītības iestādē',
        downloadPdf: 'Lejupielādēt dienasgrāmatu (PDF)',
        editIntern: 'Rediģēt praktikantu',
        assignToOrg: 'Piešķirt uzņēmumam',
        resetPwd: 'Atjaunot paroli',
      },
      downloadPdfFailed: 'Neizdevās lejupielādēt dienasgrāmatu',
      editIntern: {
        name: 'Vārds',
        lastname: 'Uzvārds',
        pk: 'Personas kods',
        email: 'E-pasts',
        nameRequired: 'Norādiet vārdu',
        lastnameRequired: 'Norādiet uzvārdu',
        emailInvalid: 'Ievadiet derīgu e-pastu',
        help: 'Ja prakse vēl notiek, mainās arī praktikanta konts: mainot e-pastu, praktikants uz jauno adresi saņems jaunu paroli. Ja prakse ir beigusies, mainās tikai šīs prakses dati.',
        save: 'Saglabāt',
        failed: 'Neizdevās saglabāt praktikanta datus',
        saved: 'Praktikanta dati saglabāti',
      },
      resetPwd: {
        warning:
          'Praktikanta kontam tiks izveidota jauna parole un nosūtīta uz {{email}}. Visas atvērtās sesijas tiks pārtrauktas.',
        warningNoEmail:
          'Praktikanta kontam tiks izveidota jauna parole un nosūtīta uz konta e-pastu. Visas atvērtās sesijas tiks pārtrauktas.',
        next: 'Tālāk',
        back: 'Atpakaļ',
        confirmTitle: 'Vai tiešām atjaunot paroli?',
        confirmText: 'Praktikanta {{name}} pašreizējā parole vairs nedarbosies.',
        confirm: 'Atjaunot paroli',
        doneTitle: 'Parole atjaunota',
        doneText: 'Jaunā parole nosūtīta uz {{email}}.',
        password: 'Jaunā parole',
        changeOnNextSignIn: 'Nākamajā pieslēgšanās reizē praktikantam būs jānomaina parole.',
        copy: 'Kopēt paroli',
        copied: 'Parole nokopēta',
        failed: 'Neizdevās atjaunot paroli',
      },
      changeEduSupervisor: {
        supervisor: 'Jaunais prakses vadītājs',
        search: 'Meklēt pēc vārda vai uzvārda',
        required: 'Izvēlieties prakses vadītāju',
        none: 'Prakses vadītāji nav atrasti',
        help: 'Praktikanta ieraksti un vērtējumi, kā arī vēl neparakstītie līgumi pāries jaunajam prakses vadītājam.',
        save: 'Saglabāt',
        loadError: 'Neizdevās ielādēt prakses vadītājus',
        failed: 'Neizdevās mainīt prakses vadītāju',
        changed: 'Prakses vadītājs mainīts',
      },
      assignToOrg: {
        title: 'Piešķirt uzņēmumam',
        email: 'Uzņēmuma prakses vadītāja e-pasts',
        emailInvalid: 'Ievadiet derīgu e-pastu',
        next: 'Tālāk',
        back: 'Atpakaļ',
        supervisor: 'Prakses vadītājs',
        supervisorRequired: 'Izvēlieties prakses vadītāju',
        individual: 'Edy365 lietotājs (Basic)',
        name: 'Vārds',
        lastname: 'Uzvārds',
        required: 'Aizpildiet lauku',
        phone: 'Tālrunis',
        language: 'Valoda',
        address: 'Prakses vietas adrese',
        orgName: 'Uzņēmuma nosaukums',
        orgRegNo: 'Reģistrācijas numurs',
        legalAddress: 'Juridiskā adrese',
        signatory: 'Parakstītājs',
        start: 'Sākums',
        end: 'Beigas',
        dateOrder: 'Beigu datumam jābūt pēc sākuma datuma',
        save: 'Saglabāt',
        lookupFailed: 'Neizdevās pārbaudīt e-pastu',
        failed: 'Neizdevās piešķirt uzņēmumu',
        assigned: 'Prakses vadītājs piešķirts',
      },
      openDate: {
        date: 'Datums',
        all: 'Atvērt visus noslēgtos datumus',
        allCount_zero: '{{count}} noslēgti datumi',
        allCount_one: '{{count}} noslēgts datums',
        allCount_other: '{{count}} noslēgti datumi',
        explanation: 'Paskaidrojums',
        help: 'Praktikants varēs ievadīt ierakstu par atvērto datumu 7 dienas.',
        none: 'Praktikantam nav noslēgtu datumu',
        save: 'Atvērt',
        loadError: 'Neizdevās ielādēt noslēgtos datumus',
        failed: 'Neizdevās atvērt datumu',
        opened_zero: 'Atvērti {{count}} datumi',
        opened_one: 'Atvērts {{count}} datums',
        opened_other: 'Atvērti {{count}} datumi',
      },
      period: {
        start: 'Sākums',
        end: 'Beigas',
        help: 'Prakses vietu un vadītāju datumi tiks pielāgoti jaunajam termiņam.',
        save: 'Saglabāt',
        failed: 'Neizdevās mainīt prakses termiņu',
        changed: 'Prakses termiņš mainīts',
        resetText: 'Praktikanta prakses datumi tiks atiestatīti uz prakses datumiem.',
        reset: 'Atiestatīt',
        resetFailed: 'Neizdevās atiestatīt prakses datumus',
        resetDone: 'Prakses datumi atiestatīti',
      },
      calendar: {
        title: 'Prakses kalendārs',
        previous: 'Iepriekšējais mēnesis',
        next: 'Nākamais mēnesis',
        today: 'Šodien',
        onSite: 'Klātienē',
        remote: 'Attālināti',
        absence: 'Prombūtne',
        week: 'Nedēļā',
        absentShort: 'prom.',
        monthTotal: 'Kopā mēnesī',
        averageGrade: 'Vidējā atzīme',
        awaitingGrade: 'Gaida vērtējumu',
        hours: '{{value}} h',
        days: '{{value}} d.',
        hint: 'Lielais skaitlis — akadēmiskās stundas. Josla — kur strādāts.',
        loadError: 'Neizdevās ielādēt kalendāru',
      },
      absence: {
        addTitle: 'Atvērt prombūtni',
        closeTitle: 'Noslēgt prombūtni',
        since: 'Prombūtne no {{date}}',
        start: 'Sākuma datums',
        end: 'Beigu datums',
        type: 'Iemesls',
        infoForOrg: 'Informācija prakses vietai',
        info: 'Iestādes piezīme',
        infoHelp: 'Redz arī praktikants',
        hours: 'Ieskaitāmās stundas',
        conclusion: 'Noslēguma piezīme',
        save: 'Saglabāt',
        dateRequired: 'Norādiet datumu',
        typeRequired: 'Norādiet iemeslu',
        textRequired: 'Aizpildiet lauku',
        hoursInvalid: 'Norādiet 0 vai vairāk stundu',
        notOpen: 'Praktikantam nav atvērtas prombūtnes',
        loadError: 'Neizdevās ielādēt prombūtni',
        failed: 'Neizdevās saglabāt prombūtni',
        added: 'Prombūtne atvērta',
        closed: 'Prombūtne noslēgta',
      },
    },
  },
  en: {
    title: 'Interns',
    description: 'All interns of the institution across every internship.',
    count_one: '{{count}} intern',
    count_other: '{{count}} interns',
    statusTabs: 'Internship status',
    statuses: {
      ongoing: 'Ongoing',
      upcoming: 'Upcoming',
      finished: 'Finished',
      all: 'All',
    },
    search: 'Search by first name, last name, personal code…',
    empty: 'No interns found',
    noOrg: 'Not assigned',
    columns: {
      group: 'Group',
      intern: 'Last name, First name',
      pk: 'Personal code',
      internship: 'Internship',
      org: 'Company',
      start: 'Start',
      end: 'End',
      hours: 'Done/Total',
      categories: 'Category',
    },
    orgs: {
      open: 'Internship places',
      openFor: 'Internship places: {{name}}',
      loading: 'Loading internship places',
      loadError: 'Could not load internship places',
      agreement: 'Agreement',
      signatures: 'Signatures',
      signature: '{{party}}: {{state}}',
      signed: 'signed',
      notSigned: 'not signed',
      parties: {
        edu: 'Educational institution',
        intern: 'Intern',
        org: 'Internship place',
      },
    },
    actions: {
      menu: 'Actions',
      menuFor: 'Actions: {{name}}',
      sections: {
        dates: 'Actions with dates',
        supervisors: 'Actions with supervisors',
        other: 'Other actions',
      },
      items: {
        openCalendar: 'View the calendar',
        openDate: 'Open a closed date',
        changeDates: 'Change internship term',
        resetDates: 'Reset internship dates',
        addAbsence: 'Open absence',
        closeAbsence: 'Close the absence',
        changeEduSupervisor: "Change the institution's supervisor",
        downloadPdf: 'Download the diary (PDF)',
        editIntern: 'Edit intern',
        assignToOrg: 'Assign to company',
        resetPwd: 'Reset password',
      },
      downloadPdfFailed: 'Could not download the diary',
      editIntern: {
        name: 'First name',
        lastname: 'Last name',
        pk: 'Personal code',
        email: 'Email',
        nameRequired: 'Enter the first name',
        lastnameRequired: 'Enter the last name',
        emailInvalid: 'Enter a valid email',
        help: "While the internship is running, the intern's account changes too: a changed email sends the intern a new password at the new address. For a finished internship only this internship changes.",
        save: 'Save',
        failed: "Could not save the intern's data",
        saved: "Intern's data saved",
      },
      resetPwd: {
        warning:
          "A new password will be created for the intern's account and sent to {{email}}. Every open session will be signed out.",
        warningNoEmail:
          "A new password will be created for the intern's account and sent to the account's email. Every open session will be signed out.",
        next: 'Next',
        back: 'Back',
        confirmTitle: 'Reset the password?',
        confirmText: "{{name}}'s current password will stop working.",
        confirm: 'Reset password',
        doneTitle: 'Password reset',
        doneText: 'The new password was sent to {{email}}.',
        password: 'New password',
        changeOnNextSignIn: 'The intern must change the password at the next sign-in.',
        copy: 'Copy password',
        copied: 'Password copied',
        failed: 'Could not reset the password',
      },
      changeEduSupervisor: {
        supervisor: 'New supervisor',
        search: 'Search by first or last name',
        required: 'Choose a supervisor',
        none: 'No supervisors found',
        help: "The intern's records and grades, and any agreements not yet signed, move to the new supervisor.",
        save: 'Save',
        loadError: 'Could not load the supervisors',
        failed: 'Could not change the supervisor',
        changed: 'Supervisor changed',
      },
      assignToOrg: {
        title: 'Assign to company',
        email: "Company supervisor's email",
        emailInvalid: 'Enter a valid email',
        next: 'Next',
        back: 'Back',
        supervisor: 'Supervisor',
        supervisorRequired: 'Choose a supervisor',
        individual: 'Edy365 user (Basic)',
        name: 'First name',
        lastname: 'Last name',
        required: 'Fill in this field',
        phone: 'Phone',
        language: 'Language',
        address: 'Internship location address',
        orgName: 'Company name',
        orgRegNo: 'Registration number',
        legalAddress: 'Legal address',
        signatory: 'Signatory',
        start: 'Start',
        end: 'End',
        dateOrder: 'The end date must be after the start date',
        save: 'Save',
        lookupFailed: 'Could not check the email',
        failed: 'Could not assign the company',
        assigned: 'Supervisor assigned',
      },
      openDate: {
        date: 'Date',
        all: 'Open all closed dates',
        allCount_one: '{{count}} closed date',
        allCount_other: '{{count}} closed dates',
        explanation: 'Explanation',
        help: 'The intern can enter a record for the opened date for 7 days.',
        none: 'The intern has no closed dates',
        save: 'Open',
        loadError: 'Could not load the closed dates',
        failed: 'Could not open the date',
        opened_one: '{{count}} date opened',
        opened_other: '{{count}} dates opened',
      },
      period: {
        start: 'Start',
        end: 'End',
        help: 'The dates of the internship places and supervisors follow the new term.',
        save: 'Save',
        failed: 'Could not change the internship term',
        changed: 'Internship term changed',
        resetText: "The intern's internship dates will be reset to the internship's dates.",
        reset: 'Reset',
        resetFailed: 'Could not reset the internship dates',
        resetDone: 'Internship dates reset',
      },
      calendar: {
        title: 'Internship calendar',
        previous: 'Previous month',
        next: 'Next month',
        today: 'Today',
        onSite: 'On site',
        remote: 'Remote',
        absence: 'Absence',
        week: 'Week',
        absentShort: 'abs.',
        monthTotal: 'Month total',
        averageGrade: 'Average grade',
        awaitingGrade: 'Awaiting a grade',
        hours: '{{value}} h',
        days: '{{value}} d.',
        hint: 'The large number is academic hours. The bar shows where the work was done.',
        loadError: 'Could not load the calendar',
      },
      absence: {
        addTitle: 'Open absence',
        closeTitle: 'Close the absence',
        since: 'Absence since {{date}}',
        start: 'Start date',
        end: 'End date',
        type: 'Reason',
        infoForOrg: 'Information for the internship place',
        info: "Institution's note",
        infoHelp: 'The intern sees it too',
        hours: 'Hours to credit',
        conclusion: 'Closing note',
        save: 'Save',
        dateRequired: 'Enter a date',
        typeRequired: 'Choose a reason',
        textRequired: 'Fill in this field',
        hoursInvalid: 'Enter 0 or more hours',
        notOpen: 'The intern has no open absence',
        loadError: 'Could not load the absence',
        failed: 'Could not save the absence',
        added: 'Absence opened',
        closed: 'Absence closed',
      },
    },
  },
}
